import { merchantUsersApi } from 'api/merchantUsers'
import Spinner from 'components/Spinner'
import { useDisplayMessage } from 'hooks/useDisplayMessage'
import { buildTranslate } from 'locales'
import { useEffect } from 'react'
import { Container } from 'react-bootstrap-five'
import Table from 'scenes/MerchantUsers/Table'

const t = buildTranslate('merchant_users')

export const UsersTab = () => {
  const { data, isLoading } = merchantUsersApi.useGetMerchantUsersQuery({})

  const [, createUserStatus] = merchantUsersApi.useCreateMerchantUserMutation({
    fixedCacheKey: 'create',
  })
  const [, updateUserStatus] = merchantUsersApi.useUpdateMerchantUserMutation({
    fixedCacheKey: 'update',
  })
  const [, inviteUserStatus] = merchantUsersApi.useSendInvitationMutation({
    fixedCacheKey: 'invitation',
  })

  const displayCreateStatusMessage = useDisplayMessage(createUserStatus.reset)
  const displayUpdateStatusMessage = useDisplayMessage(updateUserStatus.reset)
  const displayInviteStatusMessage = useDisplayMessage(inviteUserStatus.reset)

  const merchantUsers = data?.merchant_users || []

  useEffect(() => {
    if (createUserStatus.isSuccess) {
      displayCreateStatusMessage(t('new.success'), 'success')
    }
  }, [createUserStatus.isSuccess, displayCreateStatusMessage])

  useEffect(() => {
    if (updateUserStatus.isSuccess) {
      displayUpdateStatusMessage(t('edit.success'), 'success')
    }
  }, [updateUserStatus.isSuccess, displayUpdateStatusMessage])

  useEffect(() => {
    if (inviteUserStatus.isSuccess) {
      displayInviteStatusMessage(t('edit.invitation_success'), 'success')
    }
  }, [inviteUserStatus.isSuccess, displayInviteStatusMessage])

  return (
    <Spinner
      isLoading={isLoading}
      size="4x"
      className="text-center margin-top-huge"
    >
      <Container>
        <Table merchantUsers={merchantUsers} />
      </Container>
    </Spinner>
  )
}
